import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export class ConfigurationStartBeforeEvent extends BaseEvent {
	constructor() {
		super({
			eventInfo: {
				eventAction: EventAction.NonInteraction,
				eventName: `configurator - start (state before change)`,
			},
		});
	}
}
